import axios from "axios";
import { use, useEffect, useState } from "react";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function Profile({ t, lang }) {
    const navigate = useNavigate();
    const [personDetails, setPersonDetails] = useState({
        userName: "",
        mobile: "",
        school: "",
        district: "",
        grade: "",
        class: "",
        email: "",
        languageStudent: "",
        personal_interest: {},
    })
    const [imageSrc, setImageSrc] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    // useEffect(() => {
    //     const getLogDetails = () => {
    //         return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    //     };
    //     const logDetails = getLogDetails();
    //     setIsLoading(true)
    //     // console.log(logDetails);

    //     const apiUrl = `${url}auth/students/${logDetails.email}`
    //     axios.get(apiUrl)
    //         .then((response) => {
    //             // console.log(response.data);
    //             const [grade, section] = (response.data.assignedClass).split("-");
    //             setPersonDetails({
    //                 userName: response.data.userFullName,
    //                 mobile: response.data.contactNumber,
    //                 school: response.data.school,
    //                 district: response.data.district,
    //                 grade: grade,
    //                 class: section,
    //                 email: response.data.userEmail,
    //                 personal_interest: response.data.personalInterests
    //             })

    //             const apiUrl = `${url}auth/students/${logDetails.email}/profile-photo`
    //             axios.get(apiUrl)
    //                 .then((response) => {
    //                     console.log(response.data);

    //                     setIsLoading(false);
    //                 })
    //                 .catch((err) => {
    //                     console.log("error occured");
    //                 });
    //         })
    //         .catch((err) => {
    //             console.log("error occured");
    //         });
    // }, [])

    const [languageNow, setLanguageNow] = useState("");

    useEffect(() => {
        setLanguageNow(localStorage.getItem("language"));
    }, [localStorage.getItem("language")]);

    useEffect(() => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) ||
                JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (!logDetails?.email) {
            console.log("No user details found");
            setIsLoading(false);
            return;
        }

        const fetchStudentDetails = async () => {
            try {
                // Fetch student details
                 const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/students/${logDetails.email}`;
                const response = await axios.get(apiUrl, configToken);

                const [grade, section] = response.data.assignedClass.split("-");
                setPersonDetails({
                    userName: response.data.userFullName,
                    mobile: response.data.contactNumber,
                    school: response.data.school,
                    district: response.data.district,
                    grade,
                    class: section,
                    email: response.data.userEmail,
                    personal_interest: response.data.personalInterests || {},
                    languageStudent: response.data.preferredLanguage
                });

                // Fetch profile photo
                const profilePhotoUrl = `${web_url}/api/auth/students/${logDetails.email}/profile-photo`;
                const photoResponse = await axios.get(profilePhotoUrl, { ...configToken, responseType: "blob" });
                localStorage.setItem('messagePenpal', 'false');
                const imageUrl = URL.createObjectURL(photoResponse.data);

                setImageSrc(imageUrl);
            } catch (error) {
                setErrorMsg("Error occured")
                console.error("Error occurred while fetching data", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStudentDetails();

        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, []);


    return (
        <div className="pb-[150px] md:pb-[50px] xl:pb-[10px]">
            <div className="hidden xl:flex rounded-t-lg xl:mt-[30px] 2xl:mt-[70px] bg-black xl:ml-[70px] xl:mr-[20px] xl:h-[40px] 2xl:h-[50px] items-center pl-[50px] xl:text-[16px] 2xl:text-[20px] text-white ">{t('t147')}</div>
            <div className="xl:hidden pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
                <div className="flex items-center justify-start mt-[20px] lg:mx-[50px] bg-black rounded-t-lg">
                    <p className={`min-h-[20px] py-[5px] md:py-[8px] lg:py-[10px] text-white ml-[10px] ${lang === "en" ? "text-[19px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (lang === "si" ? "text-[16px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[15px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} font-medium`}>{t('t147')}</p>
                </div>
            </div>
            <div className=" lg:mx-[50px] xl:ml-[70px] xl:mr-[20px] xl:min-h-[530px] 2xl:min-h-[640px] pb-[50px]">
                {/* <div className="xl:bg-[#FFEBA9] xl:rounded-b-lg xl:ml-[70px] xl:mr-[20px] xl:min-h-[530px] 2xl:min-h-[640px]"> */}
                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex items-center justify-center md:justify-start gap-[10px] bg-[#F7FAFB] border border-[#E0E8EE] border-[2px] rounded-lg mx-[30px] xl:mx-[0px] mt-[20px] py-[20px] px-[5px] md:px-[20px]">
                                {
                                    imageSrc ?
                                        <img className="bg-black h-[100px] md:h-[130px] lg:h-[150px] xl:h-[100px] rounded-full object-contain" src={imageSrc} alt="profile" />
                                        :
                                        <img className="h-[100px] md:h-[130px] lg:h-[150px] xl:h-[100px] rounded-full" src="/images/img.jpg" alt="profile" />

                                }
                                <div className="flex flex-col justify-center items-start ">
                                    <p className={`font-medium text-[16px] md:text-[24px] lg:text-[35px] xl:text-[20px] 2xl:text-[23px] text-black`}>{personDetails.userName}</p>
                                    <p className={`font-medium text-[13px] md:text-[18px] lg:text-[25px] xl:text-[15px] 2xl:text-[16px] text-black/50`}>{personDetails.district}</p>
                                </div>
                            </div>
                            <div className="flex flex-col items-start justify-center gap-[5px]  2xl:gap-[10px] bg-[#F7FAFB] border border-[#E0E8EE] border-[2px] rounded-lg mx-[30px] xl:mx-[0px] mt-[20px] py-[20px] md:py-[10px] px-[5px] md:px-[20px]">
                                <p className={`underline underline-offset-2 pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[19px] md:text-[23px] lg:text-[30px] xl:text-[18px] 2xl:text-[25px]" : (lang === "si" ? "text-[16px] md:text-[22px] lg:text-[25px] xl:text-[15px] 2xl:text-[22px]" : "text-[15px] md:text-[19px] lg:text-[24px] xl:text-[14px] 2xl:text-[20px]")} font-[600] mb-[5px]`}>
                                    {t('t452')}
                                </p>
                                <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t441')}: <span className="font-[600]">{personDetails.email}</span>
                                </p>
                                <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t150')}: <span className="font-[600]">{personDetails.school}</span>
                                </p>
                                <p className={`md:hidden pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t149')}: <span className="font-[600]">{personDetails.district}</span>
                                </p>
                                <p className={`md:hidden pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t31')}: <span className="font-[600]">{personDetails.languageStudent}</span>
                                </p>
                                <p className={`md:hidden pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t151')}: <span className="font-[600]">{personDetails.grade}</span>
                                </p>
                                <p className={`md:hidden pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                    {t('t152')}: <span className="font-[600]">{personDetails.class}</span>
                                </p>

                                <div className="hidden md:grid grid-cols-2 grid-rows-2 gap-[5px]  2xl:gap-[10px] w-full">
                                    <p className={`pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                        {t('t149')}: <span className="font-[600]">{personDetails.district}</span>
                                    </p>
                                    <p className={`pl-[0px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                        {t('t31')}: <span className="font-[600]">{personDetails.languageStudent}</span>
                                    </p>
                                    <p className={`pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                        {t('t151')}: <span className="font-[600]">{personDetails.grade}</span>
                                    </p>
                                    <p className={`pl-[0px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                        {t('t152')}: <span className="font-[600]">{personDetails.class}</span>
                                    </p>
                                </div>

                            </div>

                            <div className="flex flex-col items-start justify-center gap-[5px] xl:gap-[10px] 2xl:gap-[10px] bg-[#F7FAFB] border border-[#E0E8EE] border-[2px] rounded-lg mx-[30px] xl:mx-[0px] mt-[20px] py-[20px] md:py-[10px] pt-[20px] pl-[5px] pr-[10px] md:px-[20px]">
                                <p className={`underline underline-offset-2 pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[19px] md:text-[23px] lg:text-[30px] xl:text-[18px] 2xl:text-[25px]" : (lang === "si" ? "text-[16px] md:text-[22px] lg:text-[25px] xl:text-[15px] 2xl:text-[22px]" : "text-[15px] md:text-[19px] lg:text-[24px] xl:text-[14px] 2xl:text-[20px]")} font-[600] mb-[5px]`}>
                                    {t('t152_2')}
                                </p>
                                {Array.isArray(personDetails?.personal_interest?.hobbies) &&
                                    <div className="flex flex-col md:flex-row md:items-start md:justify-start mt-[10px] md:mt-[0px]">


                                        <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                            {t('t167')}
                                        </p>

                                        <div className="flex flex-wrap pl-[10px] md:pl-[20px] mt-[10px] md:mt-[0px] gap-[5px]">
                                            {
                                                Array.isArray(personDetails?.personal_interest?.hobbies) &&
                                                personDetails.personal_interest.hobbies.map((hobby, index) => {
                                                    const total = personDetails.personal_interest.hobbies.length;
                                                    return (
                                                        <div key={index} className="min-w-[100px] bg-[#C6CFD7] text-[#1E1E1E] rounded-lg px-[5px] py-[3px] ml-[5px] flex items-center justify-center font-[500] mb-[5px]">
                                                            <p className={`${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                                {hobby}
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                }

                                {Array.isArray(personDetails?.personal_interest?.sports) &&
                                    <div className="flex flex-col md:flex-row md:items-start md:justify-start mt-[10px] md:mt-[0px]">
                                        <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                            {t('t168')}
                                        </p>

                                        <div className="flex flex-wrap pl-[10px] md:pl-[20px] mt-[10px] md:mt-[0px] gap-[5px]">
                                            {
                                                Array.isArray(personDetails?.personal_interest?.sports) &&
                                                personDetails.personal_interest.sports.map((sport, index) => {
                                                    const total = personDetails.personal_interest.sports.length;
                                                    return (
                                                        <div key={index} className="min-w-[100px] bg-[#C6CFD7] text-[#1E1E1E] rounded-lg px-[5px] py-[3px] ml-[5px] flex items-center justify-center font-[500] mb-[5px]">
                                                            <p className={`${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                                {sport}
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                {Array.isArray(personDetails?.personal_interest?.actors) &&
                                    <div className="flex flex-col md:flex-row md:items-start md:justify-start mt-[10px] md:mt-[0px]">

                                        <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                            {t('t169')}
                                        </p>

                                        <div className="flex flex-wrap pl-[10px] md:pl-[20px] mt-[10px] md:mt-[0px] gap-[5px]">
                                            {
                                                Array.isArray(personDetails?.personal_interest?.actors) &&
                                                personDetails.personal_interest.actors.map((actor, index) => {
                                                    const total = personDetails.personal_interest.actors.length;
                                                    return (
                                                        <div key={index} className="min-w-[100px] bg-[#C6CFD7] text-[#1E1E1E] rounded-lg px-[5px] py-[3px] ml-[5px] flex items-center justify-center font-[500] mb-[5px]">
                                                            <p className={`${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                                {actor}
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                {Array.isArray(personDetails?.personal_interest?.movies) &&
                                    <div className="flex flex-col md:flex-row md:items-start md:justify-start mt-[10px] md:mt-[0px]">

                                        <p className={`pl-[10px] md:pl-[20px] ${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                            {t('t170')}
                                        </p>

                                       <div className="flex flex-wrap pl-[10px] md:pl-[20px] mt-[10px] md:mt-[0px] gap-[5px]">
                                            {
                                                Array.isArray(personDetails?.personal_interest?.movies) &&
                                                personDetails.personal_interest.movies.map((movie, index) => {
                                                    const total = personDetails.personal_interest.movies.length;
                                                    return (
                                                        <div key={index} className="min-w-[100px] bg-[#C6CFD7] text-[#1E1E1E] rounded-lg px-[5px] py-[3px] ml-[5px] flex items-center justify-center font-[500] mb-[5px]">
                                                            <p className={`${lang === "en" ? "text-[14px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                                {movie}
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </>
                }
            </div>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Profile;